"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFormatArgsSanitizer = void 0;
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
/**
 * This is a workaround fix meant to deal with any cxIds or currencies not defined in the query set.
 *
 * For those cxIds/currencies, the fallback to ANY is not supported by ACS naturally. Besides, it is not practical
 * for us to track the newly-introduced cxIds or currency and added into our query set
 * within the size limits defined by ACS team.
 *
 * As we only need the simple fallback logic which is unknown cxId/currency to "ANY", so we can simply set
 * all cxID/currency that are not defined in ACS query space as null. This is safe for all cases except when we
 * add new entries of cxId/currency, we have to add those here to avoid shaking them off before requesting ACS.
 *
 * Ideally, the ACS team should have a better way of solving this use case but this class will unblock us from release.
 * TODO: Clean this up when ACS proposed a solution in https://issues.amazon.com/issues/ConfigPlane-FR-70
 */
class PriceFormatArgsSanitizer {
    static process(args) {
        if (!(args instanceof i18n_configuration_provider_1.PriceFormatArgs)) {
            return args;
        }
        const priceFormatArgs = args;
        const currency = !(0, i18n_configuration_provider_1.isNullOrUndefined)(priceFormatArgs.currency) ? priceFormatArgs.currency.toLowerCase() : undefined;
        const newCurrency = this.HIERARCHY_SUPPORT_CURRENCY.has(currency) ? priceFormatArgs.currency : undefined;
        const newCXId = this.HIERARCHY_SUPPORT_CX_ID.has(priceFormatArgs.cxId) ? priceFormatArgs.cxId : undefined;
        const newCXFamily = !(0, i18n_configuration_provider_1.isNullOrUndefined)(priceFormatArgs.cxFamily) ? priceFormatArgs.cxFamily : 'retail';
        const newCXProgram = this.HIERARCHY_SUPPORT_CX_PROGRAM.has(priceFormatArgs.cxProgram) ? priceFormatArgs.cxProgram : '[]';
        return new i18n_configuration_provider_1.PriceFormatArgsBuilder()
            .fromPriceFormatArgs(priceFormatArgs)
            .withCurrency(newCurrency)
            .withCxFamily(newCXFamily)
            .withCxId(newCXId)
            .withCxProgram(newCXProgram)
            .build();
    }
}
exports.PriceFormatArgsSanitizer = PriceFormatArgsSanitizer;
/**
 * The following cxId/currencies are coming from the query set we configured for ACS feature I18nPriceFormat.
 */
PriceFormatArgsSanitizer.HIERARCHY_SUPPORT_CX_ID = new Set([
    "amazon.se", "amazon.ru", "amazon.in", "amazon.com.mx", "amazon.com.au", "amazon.co.uk",
    "amazon.fr", "amazon.nl", "amazon.com", "amazon.co.jp", "amazon.eg", "amazon.pl", "amazon.es",
    "amazon.ae", "amazon.com.tr", "amazon.com.br", "amazon.ca", "amazon.de", "amazon.sg", "amazon.it",
    "amazon.cn", "amazon.sa"
]);
PriceFormatArgsSanitizer.HIERARCHY_SUPPORT_CURRENCY = new Set([
    "cny", "jpy", "sek", "cad", "inr", "usd", "egp", "ngn",
    "aed", "try", "cop", "zar", "sar", "pln", "sgd", "xts"
]);
PriceFormatArgsSanitizer.HIERARCHY_SUPPORT_CX_PROGRAM = new Set(['[]', '[exports]']);
//# sourceMappingURL=price-format-args-sanitizer.js.map